import App from './App.svelte';
const global = (new Function('return this'))();
global.App = App;
export default App;
